import { Typography } from "@mui/material";
import React from "react";
import "./Education.css";
import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { AnimationOnScroll } from "react-animation-on-scroll";
import "animate.css/animate.min.css";

function Education() {
  return (
    <div style={{ color: "white" }}>
      <AnimationOnScroll animateIn="animate__fadeIn" animatePreScroll>
        <Typography
          variant="h4"
          component="div"
          align="center"
          sx={{
            color: "#fff",
            margin: "50px",
          }}>
          Education
        </Typography>
      </AnimationOnScroll>
      <React.Fragment>
        <Timeline position="right" sx={{ position: "relative", left: "-20%" }}>
          <TimelineItem>
            <TimelineOppositeContent>2019-2023</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ marginBottom: "50px" }}>
              <AnimationOnScroll animateIn="animate__fadeIn" animatePreScroll>
                <div className="edu-content">
                  <Typography variant="h6">
                    Computer Engineering ( B.E. )
                  </Typography>
                  <Typography
                    variant="p"
                    component="div"
                    sx={{ fontSize: "16px", color: "gray" }}>
                    Government Engineering College, Gandhinagar
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontSize: "16px",
                      color: "gray",
                      marginBottom: "100px",
                    }}>
                    <i>CGPA : 8.83/10</i>
                  </Typography>
                </div>
              </AnimationOnScroll>
              <hr style={{ margin: "10px 0px" }}></hr>
            </TimelineContent>
          </TimelineItem>

          <TimelineItem>
            <TimelineOppositeContent>2017-2019</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent sx={{ marginBottom: "50px" }}>
              <AnimationOnScroll animateIn="animate__fadeIn" animatePreScroll>
                <div className="edu-content">
                  <Typography variant="h6">12th Science </Typography>
                  <Typography
                    variant="p"
                    component="div"
                    sx={{ fontSize: "16px", color: "gray" }}>
                    JeevanBharti High School,Surat
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontSize: "16px",
                      color: "gray",
                      marginBottom: "100px",
                    }}>
                    <i>Percentage : 81.50 %</i>
                  </Typography>
                </div>
              </AnimationOnScroll>
              <hr style={{ margin: "10px 0px" }}></hr>
            </TimelineContent>{" "}
          </TimelineItem>
          <TimelineItem>
            <TimelineOppositeContent>2016-2017</TimelineOppositeContent>
            <TimelineSeparator>
              <TimelineDot />
              <TimelineConnector />
            </TimelineSeparator>
            <TimelineContent>
              <AnimationOnScroll animateIn="animate__fadeIn" animatePreScroll>
                <div className="edu-content">
                  <Typography variant="h6">10th General</Typography>
                  <Typography
                    variant="p"
                    component="div"
                    sx={{ fontSize: "16px", color: "gray" }}>
                    Suman High School No. 3, Surat
                  </Typography>
                  <Typography
                    variant="p"
                    sx={{
                      fontSize: "16px",
                      color: "gray",
                      marginBottom: "100px",
                    }}>
                    <i>Percentage : 89.67 %</i>
                  </Typography>
                </div>
              </AnimationOnScroll>
              <hr style={{ margin: "10px 0px" }}></hr>
            </TimelineContent>
          </TimelineItem>
        </Timeline>
      </React.Fragment>
    </div>
  );
}

export default Education;
